export default __webpack_public_path__ + "static/media/gallery04.af043c5d.jpg";